

import React, { memo } from 'react';
import { Image } from '../../../ui-kit';
import PlayerCommonView from './PlayerCommonView';

import '../styles/_player-audio-view.scss';

const ICON_SIZE = 130;









const PlayerAudioView = (props) => {
  const { isMusicV2 = false, bgmImage = '' } = props;
  return (
    <div className="player-audio-view">
      <Image
        width="100%"
        height="100%"
        backgroundSize={isMusicV2 ? 'cover' : 'contain'}
        {...isMusicV2 ?
        { imageUrl: bgmImage } :
        {
          defaultImageIcon: 'audio',
          defaultIconSize: ICON_SIZE,
          defaultIconColour: 'michael',
          defaultIconBackground: 'black'
        }} />

      <PlayerCommonView {...props} />
    </div>);

};

export default memo(PlayerAudioView);